import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="flex items-center gap-3 cursor-pointer w-fit">
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 relative overflow-hidden">
                <div className="absolute inset-0 flex">
                  <div className="w-1/2 bg-primary-500" />
                  <div className="w-1/2 bg-accent-500" />
                </div>
                <span className="relative font-heading font-bold text-background-50 text-lg">S</span>
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-bold text-xl text-background-50">SkyEdge</span>
                <span className="text-[10px] uppercase tracking-widest text-background-300 mt-0.5">Infotech LLC</span>
              </div>
            </a>
            <p className="mt-5 text-sm leading-relaxed max-w-sm">
              Armenia-based IT company with 120+ engineers across India and Armenia,
              delivering custom software, data centre, cloud, AI agentic tools, and
              real-world asset tokenization.
            </p>
            <div className="mt-5 space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-accent-400 mt-0.5 flex-shrink-0"></i>
                <span className="text-background-300">Komitas Avenue, Yerevan, Armenia</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400 flex-shrink-0"></i>
                <a href="mailto:tokenization@skyedge.am" className="text-background-300 hover:text-accent-400 cursor-pointer transition-colors">tokenization@skyedge.am</a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-phone-line text-accent-400 mt-0.5 flex-shrink-0"></i>
                <div className="flex flex-col">
                  <a href="tel:+37455432763" className="text-background-300 hover:text-accent-400 cursor-pointer transition-colors">+374 55 432763</a>
                  <a href="tel:+971529548257" className="text-background-300 hover:text-accent-400 cursor-pointer transition-colors">+971 52 9548257</a>
                </div>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                { icon: 'ri-twitter-x-fill', label: 'Twitter' },
                { icon: 'ri-github-fill', label: 'GitHub' },
                { icon: 'ri-mail-line', label: 'Email' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5 border border-background-50/10 hover:bg-accent-500 hover:border-accent-500 text-background-100 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">Services</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/#services" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Custom Software</a></li>
              <li><a href="https://gdbcloud.com/" target="_blank" rel="noopener nofollow" className="hover:text-accent-400 cursor-pointer">GDB Data Centre</a></li>
              <li><a href="/#services" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Cloud Services</a></li>
              <li><a href="/#services" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">AI Agentic Tools</a></li>
              <li><a href="/#services" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Managed Services</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">Products</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/products/omni-ai" onClick={(e) => { e.preventDefault(); navigate('/products/omni-ai'); }} className="hover:text-accent-400 cursor-pointer">Omni AI</a></li>
              <li><a href="/products/rwa-tokenization" onClick={(e) => { e.preventDefault(); navigate('/products/rwa-tokenization'); }} className="hover:text-accent-400 cursor-pointer">RWA Tokenization</a></li>
              <li><a href="/#products" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#products')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Real Estate Marketplace</a></li>
              <li><a href="/#contact" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Request a demo</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/#about" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">About</a></li>
              <li><a href="/#industries" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#industries')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Industries</a></li>
              <li><a href="/#contact" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-accent-400 cursor-pointer">Contact</a></li>
              <li><a href="#" className="hover:text-accent-400 cursor-pointer">Careers</a></li>
              <li><a href="#" className="hover:text-accent-400 cursor-pointer">Privacy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            &copy; {year} Sky Edge Infotech LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs text-background-300">
            <span className="flex items-center gap-1.5"><i className="ri-map-pin-2-line text-accent-400"></i> Yerevan &middot; Mohali, Chandigarh</span>
            <span className="flex items-center gap-1.5"><i className="ri-shield-check-line text-accent-400"></i> ISO 27001 aligned</span>
          </div>
        </div>
      </div>
    </footer>
  );
}